export const truncate = (str) => {
  if (!str) return str;
  return str.replace(/(.{70})..+/, "$1…");
};

export const truncateLong = (str) => {
  if (!str) return str;
  return str.replace(/(.{200})..+/, "$1…");
}
